/**
 * Lexis Nexis const symbols.
 * @constant
 * @type {Object}
 */


const LEXIS_NEXIS_CONST = {
    PROFILING_SESSION_ID: 'profilingSessionId'
};


export {LEXIS_NEXIS_CONST};